export default "__VITE_ASSET__af61cae3__"